import * as amplitude from '@amplitude/unified';

import { resolveAmplitudeApiKey, resolveAnalyticsEnvironment } from './amplitude-api-key';
import { appPlatformPlugin } from './app-platform-plugin';
import { isHeadlessRoute } from './is-headless-route';

/**
 * Флаг живёт в модуле, а не в React-состоянии: в проде включён `StrictMode`
 * (`src/index.tsx`), и любой вызов из дерева выполнился бы дважды.
 */
let initialized = false;

export function initAmplitude(): void {
  if (initialized) {
    return;
  }

  if (isHeadlessRoute(window.location.pathname)) {
    return;
  }

  const environment = resolveAnalyticsEnvironment();
  const apiKey = resolveAmplitudeApiKey(environment);

  if (!apiKey) {
    // Окружение в тексте обязательно: без него непонятно, какую из трёх переменных потеряли.
    // eslint-disable-next-line no-console
    console.warn(`Amplitude API key missing for environment "${environment}" — analytics disabled`);
    return;
  }

  initialized = true;

  // Плагин регистрируется до `initAll`: `add` до готовности клиента встаёт в ту же очередь,
  // что и события (`core-client.js`), поэтому обогащение успевает встать раньше первых
  // autocapture-событий — иначе `Page Viewed` при загрузке уехал бы без метки.
  amplitude.add(appPlatformPlugin());

  amplitude.initAll(apiKey, {
    // `minIdLength: 1` — иначе сервер Amplitude отклоняет события пользователей с id короче
    // пяти символов: серверный дефолт минимальной длины — 5, а SDK уезжает с ним в payload
    // каждого запроса (`analytics-core/lib/cjs/plugins/destination.js:220`). Ставим id как
    // есть, без префикса, чтобы в интерфейсе Amplitude он совпадал с id в админке.
    analytics: { autocapture: true, minIdLength: 1 },
    sessionReplay: { sampleRate: 1 },
  });
}
